import { createAction, props } from '@ngrx/store';
import { AppointmentStatus } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { Appointment } from 'src/app/public/common/models/appointment.model';
import { Conversation } from 'src/app/public/common/models/conversation.model';


export class CommonActions {

    // Appointments

    public static appointmentNewSubmit = createAction(
        '[Car Component] appointment New Submit',
        props <{ appointment: Appointment, objectSource: ObjectSource }> ()
    );

    // public static appointmentNewSuccess = createAction(
    //     '[Car Component] appointment New Success',
    //     props <{ appointment: Appointment, objectSource: ObjectSource }> ()
    // );

    public static appointmentUpdateSubmit = createAction(
        '[Car Component] appointment Update Submit',
        props <{ appointment: Appointment, objectSource: ObjectSource }> ()
    );

    public static appointmentStatusUpdateSubmit = createAction(
        '[Car API] Update appointment status submit',
        props <{ appointmentId: number, status: AppointmentStatus, objectSource: ObjectSource }> ()
    );

    public static appointmentUpsertSuccess = createAction(
        '[Car Component] appointment Update Success',
        props <{ appointment: Appointment, objectSource: ObjectSource }> ()
    );

    // public static appointmentStatusUpdateSuccess = createAction(
    //    '[Car API] Update appointment status success',
    //     props <{ appointment: Appointment }> ()
    // );

    public static appointmentRescheduleSubmit = createAction(
        '[Car Component] appointment Reschedule Submit',
        props <{ appointmentId: number, rescDate: string, objectSource: ObjectSource }> ()
    );

    // public static appointmentRescheduleSuccess = createAction(
    //     '[Car Component] appointment Reschedule Success',
    //     props <{ appointment: Appointment }> ()
    // );

    public static fetchMyAppointmentsSubmit = createAction(
        '[SearchCriteria Component] Fetch my Appointments  Submit',
        props <{ dealerId: string }> ()
    );

    public static fetchMyAppointmentsSuccess = createAction(
        '[SearchCriteria Component] Fetch my Appointments Success',
        props <{ appointments: Appointment [] }> ()
    );


    // Conversations
    public static fetchMyConversationsSubmit = createAction(
        '[SearchCriteria Component] Fetch my Conversations  Submit',
        props <{ dealerId: string }> ()
    );

    public static fetchMyConversationsSuccess = createAction(
        '[SearchCriteria Component] Fetch my Conversations Success',
        props <{ conversations: Conversation [] }> ()
    );

}

